<template>
  <HeadingLv1 :text="title" />
  <div class="u-containar-md">
    <Loader v-if="state.isLoading" />

    <template v-if="state.isSuccess && !state.isLoading">
      <div class="box">
        <div class="box_main">
          チェックインしました
        </div>

        <p class="box_sub" v-if="eventData.applicant_type === 'EH'">
          下記の病院へご登録いただいた情報を送信いたしました
        </p>
      </div>

      <div class="about">
        <dl v-if="eventData.applicant_type === 'E'">
          <dt>イベント名</dt>
          <dd>{{ eventData.event_name || '' }}</dd>
        </dl>
        <dl v-if="eventData.applicant_type === 'EH'">
          <dt>病院名</dt>
          <dd>{{ eventData.hospital_name || '' }}</dd>
        </dl>
        <dl>
          <dt>日時</dt>
          <dd>
            {{ date }}
          </dd>
        </dl>
      </div>
    </template>

    <div
      class="error"
      v-if="state.isCheckInError && !state.isSuccess && !state.isLoading"
    >
      <p>
        チェックイン時にエラーが発生しました。大変恐れ入りますが、時間をおいてから再度チェックインしてください。
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { reactive } from 'vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import { useStore } from 'vuex'
import { axiosSetting } from '@/utils/axiosSetting'
import Loader from '@/components/elements/Loader.vue'

export default {
  name: 'MypageCheckin',

  components: {
    HeadingLv1,
    Loader
  },

  props: {
    eventData: {
      type: Object,
      default: () => ({})
    }
  },

  beforeRouteEnter: async (to: any, from: any, next: any) => {
    const getEventInfo = axiosSetting('cms', 'page')

    const result = await getEventInfo
      .get(
        `${process.env.VUE_APP_WPAPI_URL}wp-json/mynaviresident/v1/event/checkin?checkin_id=${to.params.id}`
      )
      .then((res) => {
        return res.data
      })
      .catch(() => {
        return 'error'
      })

    if (result === 'error') return next('/404')

    to.matched[0].props.default = {
      eventData: result
    }

    next()
  },

  setup(props: any) {
    const store = useStore()
    const state = reactive({
      isLoading: true,
      isSuccess: false,
      isCheckInError: false
    })

    const getTitle = (checkinType: string) => {
      if (checkinType === 'E') return 'イベント来場受付'
      return 'ブースチェックイン'
    }
    const getDate = () => {
      const week = ['日', '月', '火', '水', '木', '金', '土']
      const now = new Date()
      let date = now.getFullYear() + '年'
      date += now.getMonth() + 1 + '月'
      date += now.getDate() + '日'
      date += '(' + week[now.getDay()] + ')'

      return date
    }

    const title = getTitle(props.eventData.applicant_type)
    const date = getDate()

    const tryCheckin = () => {
      interface Params {
        event_id: number
        holding_type: number
        data: {
          applicant_type: string
          hospital_id?: string
          program_id?: string
        }[]
      }
      const params: Params = {
        event_id: props.eventData.event_id,
        holding_type: props.eventData.holding_type,
        data: [
          {
            applicant_type: props.eventData.applicant_type
          }
        ]
      }
      if (props.eventData.applicant_type === 'EH') {
        const data = [
          {
            applicant_type: props.eventData.applicant_type,
            hospital_id: props.eventData.hospital_id,
            program_id: props.eventData.program_id
          }
        ]
        params.data = data
      }
      const postCheckinInfo = axiosSetting('app', 'page')

      postCheckinInfo
        .post(`/api/v1/check_in`, params)
        .then(() => {
          state.isSuccess = true
        })
        .catch((err) => {
          try {
            if (err.response.status === 422) {
              const errors = err.response.data.err_msg

              Object.keys(errors).forEach((key: string) => {
                alert(errors[key][0])
              })
              return
            }
            if (err.response.status === 504) {
              state.isCheckInError = true
              return
            }

            store.commit('showSystemError', 'modal')
          } catch (e) {
            store.commit('showSystemError', 'modal')
          }
        })
        .then(() => {
          state.isLoading = false
        })
    }
    tryCheckin()

    return {
      state,
      title,
      date
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.box {
  border: 2px solid var.$color-main;
  color: var.$color-main;
  margin-top: 50px;
  margin-bottom: 40px;
  padding: 16px 20px;
  text-align: center;
  line-height: 1.5;

  &_main {
    font-size: 1.8rem;
    font-weight: bold;
  }

  &_sub {
    margin-top: 12px;
  }
}

.about {
  margin-bottom: 45px;
  line-height: 1.5;

  dl {
    display: flex;
    & + dl {
      margin-top: 10px;
    }
  }

  dt {
    flex-basis: 100px;
    flex-shrink: 0;
    font-weight: bold;
    margin-right: 1em;
  }

  dd {
    flex-grow: 1;
  }
}
.error {
  padding: 10px 15px;
  line-height: 1.78;
  border: 1px solid #f64545;
  color: #f64545;
  margin-bottom: 16px;
}
</style>
